function openSearch() {
  document.querySelector('.header-right-panel').classList.add('search-open');
  document.querySelector('.header-search-container').classList.add('open');
  document.querySelector('.header-search-cancel').classList.add('open');
  document.querySelector('.header-search-input-shopify').placeholder = 'Search for products';
  document.querySelector('.header-container').classList.add('search-open');
}
function closeSearch() {
  document.querySelector('.header-right-panel').classList.remove('search-open');
    document.querySelector('.header-center-panel').classList.remove('search-open');
    document.querySelector('.header-left-panel').classList.remove('search-open');
    document.querySelector('.header-account').classList.remove('search-open');

    document.querySelector('.header-search-container').classList.remove('open');
    document.querySelector('.header-search-cancel').classList.remove('open');
    document.querySelector('.header-search-input-shopify').placeholder = '';
    document.querySelector('.header-search-input-shopify').value = '';
    document.querySelectorAll('.predictive-search-results')?.forEach((predictive) => {
      predictive.innerHTML = '';
    });

    // Mobile search
    document.querySelector('.header-search-mobile-bar').classList.remove('search-open');
    document.querySelector('.mobile-predictive-search-results').classList.remove('search-open');
    document.querySelector('.header-container').classList.remove('search-open');
}
function openCartDrawer() {
  window.dispatchEvent(new CustomEvent('open-cart-drawer'));
}
function openMobileSearch() {
  document.querySelector('.header-search-mobile-bar').classList.add('search-open');
  document.querySelector('.mobile-predictive-search-results').classList.add('search-open');
  document.querySelector('.header-container').classList.add('search-open');  
}
function closeMobileSearch() {
  document.querySelector('.header-search-mobile-bar').classList.remove('search-open');
  document.querySelector('.mobile-predictive-search-results').classList.remove('search-open');

  closeSearch();
  document.querySelector('.header-container').classList.remove('search-open');
}
function updateSearchInput() {
  const searchInput = document.querySelector('.header-search-mobile-bar-input-shopify');
  const desktopSearchInput = document.querySelector('.header-search-input-shopify');
  desktopSearchInput.value = searchInput.value;
  debouncedPredictiveSearch();
}
function predictiveSearch() {
  const predictiveSearchSections = document.querySelectorAll('.predictive-search-results');
  const desktopSearchInput = document.querySelector('.header-search-input-shopify');

  if (desktopSearchInput.value) {

    let requestResponse;

    fetch(`/search?q=${desktopSearchInput.value}&type=product`).then((response) => {
        requestResponse = response;
        return response.text();
      }).then((text) => {
        if(!requestResponse.ok) {
          throw new Error(`${requestResponse.status}: ${text}`);
        }
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-predictive-search').innerHTML;
          if (resultsMarkup === null) {
            predictiveSearchSections.forEach((predictive) => {
              predictive.innerHTML = '';
            });
          } else {
            predictiveSearchSections.forEach((predictive) => {
              predictive.innerHTML = resultsMarkup;
              predictive.querySelector('#shopify-predictive-search')?.classList.remove('hide');
            });
          }
      })
      .catch((error) => {
        console.error(error);
      });
  } else {
    predictiveSearchSections.forEach((predictive) => {
      predictive.innerHTML = '';
    });
  }
}
const debouncedPredictiveSearch = debounce(predictiveSearch, 400);


window.addEventListener('scroll', function () {
  const header = document.querySelector('.header-container') || null;
  const menu = document.querySelector('.menu-container') || null;
  if (header && menu) {
    if (window.scrollY > 0) {
      header.classList.add('scrolled');
      menu.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
      menu.classList.remove('scrolled');
    }
  }
});

/** Function header Menu */

function setMenuTop() {
if (document.querySelector('.component-header-menu') && document.querySelector('.header-widget-wrapper')) {
  document.querySelector('.component-header-menu').style.top = document.querySelector('.header-widget-wrapper').offsetHeight + 'px';
}
}
const ro = new ResizeObserver(entries => {
for (let entry of entries) {
  setMenuTop();
}
});
ro.observe(document.querySelector('.header-widget-wrapper'));